<template>
    <LiefengContent>
        <template v-slot:title>
            用户列表
            <span class="eye" @click.stop="changeEye">
                <Icon :type="hasSensitive ? 'md-eye-off' : 'md-eye'" />
            </span>
        </template>
        <template v-slot:toolsbarRight>
            <Form :label-colon="true" :inline="true" class="search">
                <FormItem>
                    <Input :maxlength="20" v-model.trim="searchData.realName" placeholder="真实姓名" style="width: 150px; margin-right: 10px" @on-enter="search" />
                </FormItem>
                <FormItem>
                    <Input :maxlength="11" v-model.trim="searchData.mobile" placeholder="手机号" style="width: 150px; margin-right: 10px" @on-enter="search" />
                </FormItem>
                <Button type="primary" icon="ios-search" @click="search">搜索</Button>
                <Button type="success" icon="ios-refresh" style="margin-left: 10px" @click="reset">重置</Button>
            </Form>
        </template>
        <template v-slot:contentArea>
            <LiefengTable
                :talbeColumns="tableColumns"
                :tableData="tableData"
                :loading="loading"
                :fixTable="true"
                :curPage="page"
                :total="total"
                :pagesizeOpts="[20, 30, 50, 100]"
                :page-size="pageSize"
                @hadlePageSize="getList"
            ></LiefengTable>
        </template>
    </LiefengContent>
</template>

<script>
//@route('/orguserlist')
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"

export default {
    components: {
        LiefengContent,
        LiefengTable,
    },
    data() {
        return {
            orgCode: "",
            hasSensitive: true,
            loading: false,
            tableData: [],
            page: 1,
            pageSize: 20,
            total: 0,
            searchData: {
                realName: "",
                mobile: "",
            },
            tableColumns: [
                {
                    title: "昵称",
                    key: "nickName",
                    minWidth: 140,
                    align: "center",
                },
                {
                    title: "真实姓名",
                    key: "realName",
                    minWidth: 120,
                    align: "center",
                },
                {
                    title: "性别",
                    key: "sex",
                    width: 80,
                    align: "center",
                    render: (h, params) => {
                        const sex = params.row.sex
                        return h("div", sex == "1" ? "男" : sex == "2" ? "女" : "未知")
                    },
                },
                {
                    title: "生日",
                    key: "birthday",
                    minWidth: 120,
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "div",
                            params.row.birthday ? this.$core.formatDate(new Date(params.row.birthday), "yyyy-MM-dd") : ""
                        )
                    },
                },
                {
                    title: "年龄",
                    key: "age",
                    width: 80,
                    align: "center",
                },
                {
                    title: "手机号",
                    key: "mobile",
                    minWidth: 140,
                    align: "center",
                },
                {
                    title: "注册时间",
                    key: "createTime",
                    minWidth: 170,
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "div",
                            params.row.createTime
                                ? this.$core.formatDate(new Date(params.row.createTime), "yyyy-MM-dd hh:mm:ss")
                                : ""
                        )
                    },
                },
                {
                    title: "最近登录时间",
                    key: "modifyTime",
                    minWidth: 170,
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "div",
                            params.row.modifyTime
                                ? this.$core.formatDate(new Date(params.row.modifyTime), "yyyy-MM-dd hh:mm:ss")
                                : ""
                        )
                    },
                },
            ],
        }
    },
    mounted() {
        this.orgCode = this.$route.query.orgCode || ""
        if (!this.orgCode) {
            this.$Message.warning({
                background: true,
                content: "缺少机构参数 orgCode，无法加载用户列表",
            })
            return
        }
        this.getList()
    },
    methods: {
        getList(data) {
            if (!this.orgCode) {
                this.tableData = []
                this.total = 0
                return
            }
            if (data && data.page) {
                this.page = data.page
                this.pageSize = data.pageSize
            }
            this.loading = true
            this.$get("/gateway/apps/basic/api/base/userInfo/selectOrgUserPage", {
                orgCode: this.orgCode,
                realName: this.searchData.realName,
                mobile: this.searchData.mobile,
                page: this.page,
                pageSize: this.pageSize,
                hasSensitive: this.hasSensitive,
            })
                .then(res => {
                    this.loading = false
                    if (res.code === "200" || res.code === 200) {
                        this.tableData = res.dataList || []
                        this.total = res.maxCount || 0
                        this.page = res.currentPage || this.page
                    } else {
                        this.$Message.error({
                            background: true,
                            content: res.desc || "数据获取失败",
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                    this.$Message.error({
                        background: true,
                        content: "数据获取失败",
                    })
                })
        },
        changeEye() {
            this.hasSensitive = !this.hasSensitive
            this.getList({
                page: this.page,
                pageSize: this.pageSize,
            })
        },
        search() {
            this.getList({
                page: 1,
                pageSize: this.pageSize,
            })
        },
        reset() {
            this.searchData = {
                realName: "",
                mobile: "",
            }
            this.getList({
                page: 1,
                pageSize: this.pageSize,
            })
        },
    },
}
</script>

<style scoped lang="less">
.eye {
    margin-left: 10px;
    cursor: pointer;
}
</style>
